jQuery(function () {
  // Menu movil

  var menuAbierto = false;
  $(".menu-movil").on("click", function () {
    $(this).toggleClass("close");
    if (!menuAbierto) {
      $("body").addClass("blocked");
      $(".menu-wrapper").toggleClass("close");
      if ($(window).scrollTop() < 80) {
        $('.preheader').addClass('menu-active');
      }
      setTimeout(function () {
        $(".main-nav-wrapper").toggleClass("close");
        if (!$("header").hasClass("scrolled")) {
          $("header").addClass("semi-scrolled");
        }
      }, 350);
    } else {
      $(".main-nav-wrapper").toggleClass("close");
      setTimeout(function () {
        $(".menu-wrapper").toggleClass("close");
        if ($("header").hasClass("semi-scrolled")) {
          $("header").removeClass("semi-scrolled");
        }
        $("body").removeClass("blocked");
        $('.preheader').removeClass('menu-active');
      }, 250);
    }
    menuAbierto = !menuAbierto;
  });

  function toggleLogos() {
    
    if (window.matchMedia("(min-width: 1200px)").matches) {
      var scrollPosition = $(this).scrollTop();

      if (scrollPosition > 100) {
        $('.menu-logos').addClass('scrolled');
        $('.davante-full').removeClass('brand-show').addClass('brand-hide');
        $('.davante-symbol').removeClass('brand-hide').addClass('brand-show');
      
    
      } else {
        $('.menu-logos').removeClass('scrolled');
        $('.davante-symbol').removeClass('brand-show').addClass('brand-hide');
        $('.davante-full').removeClass('brand-hide').addClass('brand-show');
  
      }
    }
  }

  // Tabs de mapas en el modulo de mapas


  if ($('.module-tabs-link').length) {
    $('.module-tabs-link').on('click', function (e) {
      e.preventDefault();

      const $clicked = $(this);

      if ($clicked.hasClass('active')) return;

      const targetId = $clicked.data('tab');
      const $target = $(targetId);
      const $current = $('.map-wrapper-delegacion.map-active');

      $('.module-tabs-link').removeClass('active');
      $clicked.addClass('active');

      if (!$current.length) {
          $target.addClass('map-active').css({ opacity: 1, transform: 'translateY(0)' });
          return;
      }

      $current.css({ transition: 'opacity 0.25s ease, transform 0.25s ease' });
      $current.css({ opacity: 0, transform: 'translateY(8px)' });

      setTimeout(function () {
          $current.removeClass('map-active').css({ opacity: '', transform: '', transition: '' });

          $target.css({ opacity: 0, transform: 'translateY(-8px)', transition: 'none' });
          $target.addClass('map-active');

          $target[0].offsetHeight;

          $target.css({ transition: 'opacity 0.3s ease, transform 0.3s ease' });
          $target.css({ opacity: 1, transform: 'translateY(0)' });

          setTimeout(function () {
              $target.css({ opacity: '', transform: '', transition: '' });
          }, 300);

      }, 250);
    });
  }



  $(".slick-form-multistep").slick({
    arrows: false,
    draggable: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
  });

  $('.multistep-categoria').on('click', function(e) {
    e.preventDefault();

    cargaCursosMultistep($(this));
  })

  $('.multistep-cursos').on('click',function() {
    $(".slick-form-multistep").slick("slickPrev");
    $('#form-multistep .pasos span').text('1');
  });

  // Volvemos al paso 1 si pulsamos el boton del form
  $('.btn-back').on('click',function() {
    $(".slick-form-multistep").slick('slickGoTo', 1);
    $('#form-multistep .pasos span').text('2');
  });

  function showBottomBar() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      var scrollPosition = $(this).scrollTop();
      if (scrollPosition > 200) {
        $('.nav-footer-mvl').addClass('nav-scrolled');
      } else {
        $('.nav-footer-mvl').removeClass('nav-scrolled');
      }
    }
  }

  // Ejecutamos la funcion de cambiar logos y mostrar barra inferior de contacto
  // por si el usuario refresca pantalla 
  // en mitad de la web

    showBottomBar();
    toggleLogos();
  

  $(window).on('scroll', function() {
    showBottomBar();
    toggleLogos();
  })

  // Submenu movil

  $(".open-sub").each(function () {
    $(this).on("click", function (e) {
      if (window.matchMedia("(max-width: 1199px)").matches) {
        e.preventDefault();
        let toOpen = $(this).data("submenu");
        $('#' + toOpen).toggleClass("close open");
      }
    });
  });

  $(".subdrop-back").on("click", function () {
    if ($(".subdrop").hasClass("open")) {
      $(".subdrop").removeClass("open").addClass("close");
    }
  });

  // Enlaces footer

  $('.footer-link-title').each(function() {
    $(this).click(function() {
      if (window.matchMedia("(max-width: 1199px)").matches) {
        const drop = $(this).next();
        const dropList = drop.find('ul');
        if (drop.hasClass('drop-open')) {
          dropList.removeClass('nav-visible');
          setTimeout(function() {
            drop.removeClass('drop-open');
          },50)

        } else {
          drop.addClass('drop-open');
          setTimeout(function() {
            dropList.addClass('nav-visible');
          },350)
        }
        $(this).toggleClass("open close");
        
      }
    })
  });

  // Dropdown modulo temario ficha

  $('.module-temario-toggle').each(function() {
      $(this).on('click',function () {
          $(this).next().slideToggle();
      })
  });


  // Incrementa los numeros del modulo data-grid

  if ($('.module-data-grid').length) {
    function animateNumber($el) {
      var raw = $el.text().replace(/\./g, '').replace(/,/g, '');
      var target = parseInt(raw, 10);
      if (isNaN(target)) return;

      var duration = 2500;
      var start = null;

      function easeOutQuad(t) {
          return t * (2 - t);
      }

      function step(timestamp) {
          if (!start) start = timestamp;
          var progress = Math.min((timestamp - start) / duration, 1);
          var eased = easeOutQuad(progress);
          var current = Math.floor(eased * target);

          $el.text(current.toLocaleString('es-ES'));

          if (progress < 1) {
              requestAnimationFrame(step);
          } else {
              $el.text(target.toLocaleString('es-ES'));
          }
      }

      requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var $el = $(entry.target);
                if (!$el.data('animated')) {
                    $el.data('animated', true);
                    animateNumber($el);
                }
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    $('.card-data-xl-header-numbers').each(function () {
        observer.observe(this);
    });
  }

  // Slider Equipo

  const $configEquipo = {
    arrows: true,
    autoplay: false,
    infinite: true,
    mobileFirst: true,
    slidesToShow: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 6,
          variableWidth: false,
        },
      },
    ],
  }

  creaSlick('slick-equipo', $configEquipo);

  // Sliders Opiniones
  const $opionionesConfig = {
    arrows: true,
    autoplay: false,
    mobileFirst: true,
    slidesToShow: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  }

  creaSlick('slick-opiniones', $opionionesConfig);

  // Slider Articulos Blog

  const $articulosConfig = {
    arrows: true,
    autoplay: false,
    infinite: true,
    mobileFirst: true,
    slidesToShow:1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,

        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          
        },
      },
    ],

    // rows: 1,
    // slidesPerRow: 3,
    
  }

  creaSlick('slick-articulos', $articulosConfig);

  const $collageConfig = {
    autoplay: false,
    arrows: true,    
    infinite: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll:1,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerMode: true, 
          centerPadding: '60px',
          variableWidth:true,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          centerMode: true, 
          centerPadding: '80px',
          variableWidth:true,
        },
      },
    ]
  }

    creaSlickCollage('slick-collage', $collageConfig);

  // const $collageVerticalConfig = {
  //   adaptiveHeight: false,
  //   arrows: false,
  //   autoplay: false,
  //   infinite: false,
  //   slidesToScroll: 1,
  //   swipeToSlide: true,
  //   slidesToShow: 1,
  //   touchThreshold: 15,
  //   vertical: true,
  //   verticalSwiping: true
  // };

  // creaSlick('slick-collage-vertical', $collageVerticalConfig);

  // Slider Cursos
  const $coursesConfig = {
    arrows: true,
    autoplay: false,
    infinite: true,
    mobileFirst: true,
    slidesToShow: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          variableWidth: false
        },
      },
    ],
  }
  creaSlick('slick-courses', $coursesConfig);

  // Slick logos

  const $logosConfig = {
    arrows: true,
    autoplay: false,
    centerMode: true,       
    centerPadding: '40px',
    infinite: true,
    mobileFirst: true,
    slidesToShow: 2,
    variableWidth:true,
    responsive: [
      {
        breakpoint: 767,
        slidesToShow:5,
        settings: {
          centerPadding: '80px',
        },
      },
      {
        breakpoint: 1199,
        slidesToShow:6,
        settings: {
          centerPadding: '120px',
        },
      },
    ]
  }

  
  creaSlick('slick-logos', $logosConfig);

  // Cards Vertical Highlighted

  $(function () {
    const $sliders = $('.slick-cards-vertical-highlighted');
    if (!$sliders.length) return;

    $sliders.each(function () {
      const $slider = $(this);
      const $footer = $slider.next('.slider-footer');
      if (!$footer.length) return;

      const $rangeElement = $footer.find('.slick-progress');
      const $progressBar = $footer.find('.slick-progress-bar');
      const $prevArrow = $footer.find('.slick-prev');
      const $nextArrow = $footer.find('.slick-next');

      let slickInstance = null;
      let totalSlides = 0;
      let isAnimating = false;

      function updateProgress(currentSlide) {
        if (!slickInstance || !totalSlides) return;
        const logicalIndex = currentSlide % totalSlides;
        const leftPercent = (logicalIndex / totalSlides) * 100;
        $progressBar.css('left', leftPercent + '%');
      }

      $slider.on('init', function (event, slick) {
        slickInstance = slick;
        totalSlides = slick.slideCount;

        const $slides = $(slick.$slides);
        const initialIndex = slick.currentSlide || 0;

        $slides.removeClass('is-expanded');
        $slides.eq(initialIndex).addClass('is-expanded');

        $rangeElement.attr('max', totalSlides);
        $progressBar.css('width', 100 / totalSlides + '%');

        if (slick.options.slidesToShow >= totalSlides) {
          $rangeElement.addClass('hidden');
          $('.slider-footer').hide();
        } else {
          $rangeElement.removeClass('hidden');
          $('.slider-footer').show();
        }

        updateProgress(initialIndex);
      });

      $slider.on('afterChange', function (event, slick, currentSlide) {
        const $slides = $(slick.$slides);

        $slides.removeClass('is-expanded');
        $slides.eq(currentSlide).addClass('is-expanded');

        updateProgress(currentSlide);
        isAnimating = false;
      });

      $slider.slick({
        arrows: false,
        autoplay: false,
        mobileFirst: true,
        infinite: true,
        slidesToShow: 1,
        variableWidth: true,
        speed: 380,
        cssEase: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
        swipe: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              draggable:false,
              slidesToShow: 2,
              swipe:false
            },
          },
        ],
      });

      function go(direction) {
        if (isAnimating) return;

        const slick = slickInstance || $slider.slick('getSlick');
        if (!slick) return;

        const $slides = $(slick.$slides);
        const currentIndex = slick.currentSlide;
        const $currentSlide = $slides.eq(currentIndex);

        isAnimating = true;
        $currentSlide.removeClass('is-expanded');

        const $target = $currentSlide;
        let transitioned = false;

        $target.one('transitionend webkitTransitionEnd oTransitionEnd', function () {
          if (transitioned) return;
          transitioned = true;

          if (direction === 'next') {
            $slider.slick('slickNext');
          } else {
            $slider.slick('slickPrev');
          }
        });

        setTimeout(function () {
          if (transitioned) return;
          transitioned = true;

          if (direction === 'next') {
            $slider.slick('slickNext');
          } else {
            $slider.slick('slickPrev');
          }
        }, 420);
      }

      $prevArrow.on('click', function (e) {
        e.preventDefault();
        go('prev');
      });

      $nextArrow.on('click', function (e) {
        e.preventDefault();
        go('next');
      });
    });
  });

  // Anima las cards de equipo

  if ($('.card-equipo-back').length) {
    $('.card-equipo').each(function() {
      const $card = $(this);

      $card.find('.enable-animation').on('click', function() {
        $card.find('.card-equipo-back').addClass('activated');
      })
      $card.find('.disable-animation').on('click', function() {
        $card.find('.card-equipo-back').removeClass('activated');
      })
    })
  }
});

// Función generadora de Slicks

function creaSlick(selector,config) {
  const $slider = $(`.${selector}`);
  if ($slider.length > 0) {
    $slider.each(function() {
      // Creamos los contenedores basicos

      const $selector = $(this).next('.slider-footer');
      const $rangeElement = $selector.find('.slick-progress');
      const $progressBar = $selector.find('.slick-progress-bar');
      
      const $prevArrow = $selector.find('.slick-prev');
      const $nextArrow = $selector.find('.slick-next');

      $(this).slick(
        {...config,  
          prevArrow: $prevArrow,
          nextArrow: $nextArrow,
        }
      )
  
      // Configuración inicial barra 
      
      const totalSlides = $(this).slick('getSlick').slideCount;
      $rangeElement.attr('max', totalSlides);
      $progressBar.css('width', 100 / totalSlides + 'px');

      if($(this).slick('getSlick').options.slidesToShow >= totalSlides)
        $rangeElement.addClass('hidden');
  
      // Actualizar barra de progreso después del cambio

      $(this).on('afterChange', function (event, slick, currentSlide) {
        $progressBar.css('left', (currentSlide / totalSlides) * 100 + '%');
      });
      
    })
  }
}

// Funcion generadora de slicks para collage 

function creaSlickCollage(selector,config) {
  const $slider = $(`.${selector}`);
  if ($slider.length > 0) {
    $slider.each(function() {
      const $selector = $(this).next('.slider-footer-collage');
      const $rangeElement = $selector.find('.slick-progress');
      const $progressBar = $selector.find('.slick-progress-bar');

      const $prevArrow = $selector.find('.slick-prev');
      const $nextArrow = $selector.find('.slick-next');

      $(this).slick(
        {...config,
          prevArrow: $prevArrow,
          nextArrow: $nextArrow,
        }
      )

      const totalSlides = $(this).slick('getSlick').slideCount;
      $rangeElement.attr('max', totalSlides);
      $progressBar.css('width', 100 / totalSlides + 'px');

      if($(this).slick('getSlick').options.slidesToShow >= totalSlides)
        $rangeElement.addClass('hidden');

      $(this).on('afterChange', function (event, slick, currentSlide) {
        $progressBar.css('left', (currentSlide / totalSlides) * 100 + '%');
      });

    })
  }
}

function goTo(id, errorForm = '') {
  $("html, body").animate({ scrollTop: $("#" + id).offset().top }, "slow");

  if (!empty(errorForm)) {
    errorField = 'general';
    errorMessage = errorForm;
    enviarEventoFormulario(4, id);
  }
}

function empty(mixed_var) {
  //  discuss at: http://phpjs.org/functions/empty/
  // original by: Philippe Baumann
  //    input by: Onno Marsman
  //    input by: LH
  //    input by: Stoyan Kyosev (http://www.svest.org/)
  // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Onno Marsman
  // improved by: Francesco
  // improved by: Marc Jansen
  // improved by: Rafal Kukawski
  //   example 1: empty(null);
  //   returns 1: true
  //   example 2: empty(undefined);
  //   returns 2: true
  //   example 3: empty([]);
  //   returns 3: true
  //   example 4: empty({});
  //   returns 4: true
  //   example 5: empty({'aFunc' : function () { alert('humpty'); } });
  //   returns 5: false

  var undef, key, i, len;
  var emptyValues = [undef, null, false, 0, "", "0"];

  for (i = 0, len = emptyValues.length; i < len; i++) {
    if (mixed_var === emptyValues[i]) {
      return true;
    }
  }

  if (typeof mixed_var === "object") {
    for (key in mixed_var) {
      // TODO: should we check for own properties only?
      //if (mixed_var.hasOwnProperty(key)) {
      return false;
      //}
    }
    return true;
  }

  return false;
}

$(document).on('click', '.llamanos-btn', function () {
  jQuery.ajax({
    type: 'POST',
    url: rutajs + 'lib/ajax.php',
    data: 'fn=getModalTeLlamamos&iw=' +
      cdn_idweb +
      '&rcdn=' +
      cdn_rutacdn +
      '&rw=' +
      cdn_rutaweb,
    success: function (data) {
      if (data != '' && jQuery('#btn-llamamos').length == 0) {
        $('body').append(data);
        
        $(".overlay").fadeIn(500);
        $("body").addClass("blocked");
        $("#btn-llamamos").addClass("visible");

        setTimeout(function(){
          $('body').append("<script src='"+cdn_rutacdn+"llamamos/js/llamamos.js?v="+cdn_v+"'></script>");
        }, 1000);
      }
    },
  });
});

//Añadir el solicitar info que cuelo irá con el CDN
$(document).on('click', '.solicita-informacion', function (e) {
  var esLlamada = $(this).is('#customEnlaceLlamadaFueraHorario');
  var eventoWeb = $(this).data('evento');

  cargaModal(e, null, null, eventoWeb, esLlamada);
});

// Metemos las tablas creadas mediante CMS dentro del Div
// correspondiente para poder usar el overflow

$('.textos-legales-section table').each(function() {
  var $div = $('<div>', { class: 'textos-legales-table' });
  
  $(this).wrap($div);
});

function cargaModal(e = null, categoria = null, curso = null, eventoWeb = undefined, esLlamada = false) {
  if (e && typeof e.stopPropagation === 'function') {
    e.preventDefault();
    e.stopPropagation();
  }
    
  if(!empty(categoria))
    catCuponPost = categoria;
  else
    catCuponPost = catCupon;

  if(!empty(curso))
    curCuponPost = curso;
  else
    curCuponPost = curCupon;

  if(eventoWeb == undefined)
    eventoWeb = 'Solicita_info';

  // Si tengo definido el client_id (variable de session_id) y abro el modal, hago un push al datalayer
  if (v_client_id != undefined){
    dataLayer = (typeof dataLayer !== 'undefined') ? dataLayer : [];

    dataLayer.push({
        event: "open_generic",
        customer_id: v_client_id,
        template: v_template,
        menu_level_1: v_menu_level_1,
        menu_level_2: v_menu_level_2,
        menu_level_3: v_menu_level_3,
        menu_level_4: v_menu_level_4,
        menu_level_5: v_menu_level_5,
        form_id: datalayerFormID,
        page_path: v_page_path,
        page_url: v_page_url
    });

    valorTipoCupon = 'Modal';
    enviarEventoViewForm('form-modal');
  }

  if(!empty(curCuponPost)) {
    mostrarOcultarSpinner(true, '.overlay');

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getModalCupon&esl=' +
        esLlamada +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&eventoWeb=' +
        eventoWeb +
        '&fullWidth=' +
        JSON.parse(fullWidth),
      success: function (data) {
        if (data != '' && jQuery('#form-modal').length == 0) {
          $('body').append(data);
                
          $(".overlay").fadeIn(500);
          $("body").addClass("blocked");
    
          $(".slick-form-modal").slick({
            adaptiveHeight: true,
            arrows: false,
            draggable: false,
            fade:true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
          });

          $("#datosCupon").html("");

          jQuery.ajax({
            type: "POST",
            async: true,
            url: rutajs + "lib/ajax.php",
            data: 'fn=getCupon&idCursoComercial=' + curCuponPost +
              '&isModal=' +
              '-modal' +
              '&iw=' +
              cdn_idweb +
              '&rcdn=' +
              cdn_rutacdn +
              '&pCupon=' +
              encodeURIComponent(pCupon) +
              '&rw=' +
              cdn_rutaweb,
            success: function (data) {
              if (data != '') {               
                $('#datosCupon').append(data);

                $(".slick-form-modal").slick("slickGoTo", 2);
                $(".modal-main-wrapper .pasos span").text("3");
                $(".modal-main-wrapper .title-cabecera").text("¿Dónde contactamos contigo?");
                $(".modal-overlay").css("max-width", "600px");

                if(hideBtnBackModal) {
                  $(".modal-main-wrapper .pasos").hide();
                  $(".modal-main-wrapper .btn-back").hide();
                  $(".modal-main-wrapper .button-row").css('display', 'block');
                }

                if(fullWidth) {
                  $(".modal-overlay").css("max-width", "max-content");
                }

                enviarEvento();
              }

              if(typeof loadRecaptchaLibrary === 'function')
                loadRecaptchaLibrary();
            },
          }).done(function(){
            $("#form-modal").addClass("visible");
            mostrarOcultarSpinner(false, '.overlay');

            setTimeout(function () {
              $('.slick-form-modal').slick('setPosition');
            }, 1000);
          });
        }
      },
    })
  } else {
    mostrarOcultarSpinner(true, '#form-modal');

    jQuery.ajax({
      type: 'POST',
      async: true,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getModalCupon&esl=' +
        esLlamada +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&eventoWeb=' +
        eventoWeb +
        '&fullWidth=' +
        JSON.parse(fullWidth),
      success: function (data) {
        if (data != '' && jQuery('#form-modal').length == 0) {
          $('body').append(data);
          
          $(".overlay").fadeIn(500);
          $("body").addClass("blocked");
          $("#form-modal").addClass("visible");
  
          $(".slick-form-modal").slick({
            adaptiveHeight: true,
            arrows: false,
            draggable: false,
            fade:true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
          });
  
          if(fullWidth) {
            $(".modal-overlay").css("max-width", "max-content");
          }
  
          $("#step-modal-categoria a").each(function () {
            $(this).on("click", function (e) {
              e.preventDefault();
  
              cargaCursos($(this));
            });
          });
          $(".back-1").on("click", function () {
            $(".step-tipo-formacion-nombre").hide();
            $(".slick-form-modal").slick("slickGoTo", 0);
  
            if(!fullWidth)
              $(".modal-overlay").css("max-width", "1015px");
          });
          $(".back-2").on("click", function () {
            $(".slick-form-modal").slick("slickGoTo", 1);
  
            if(!fullWidth)
              $(".modal-overlay").css("max-width", "1015px");
          });
          $(".btn-back").on("click", function () {
            $(".slick-form-modal").slick("slickGoTo", 1);
            $(".modal-main-wrapper .pasos span").text("2");
            $(".modal-main-wrapper .title-cabecera").text("Infórmate gratis y sin compromiso");
  
            if(!fullWidth)
              $(".modal-overlay").css("max-width", "1000px");
          });
          $(".btn-form").on("click", function (e) {
            e.preventDefault();
            $(".slick-form-modal").slick("slickGoTo", 5);
            $(".modal-main-wrapper .pasos span").text("2");
            $(".modal-main-wrapper .title-cabecera").text("¿Dónde contactamos contigo?");
          });
        }
      },
    }).done(function(){
      if (aCatCupon != '' && aCatCupon != undefined) {
        $('.multiselector-modal-categoria').closest('li').hide();
        
        $.each(aCatCupon, function(index, value) {
          $('#categoria-modal-' + value).closest('li').show();
        });
      }
  
      if (catCuponPost != '' && catCuponPost != undefined)
        $('#categoria-modal-' + catCuponPost).click();

      setTimeout(function () {
        $('.slick-form-modal').slick('setPosition');
      }, 1000);
    });
  }
}

function cargaCursos(element) {
  var idCategoria = element.data('categoria');
  var sNombre = element.data('name');

  if (idCategoria != "") {
    mostrarOcultarSpinner(true, '#form-modal');

    $("#stepCursoModal").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCursos&idCategoria=" + idCategoria,
      success: function (data) {

        data = JSON.parse(data);

        if (!empty(data.aCursos)) {
          html = '';
          cursoDefault = data.aCursos[0];
          idGrupo = cursoDefault.idGrupo;
          nGrupo = "";

          if (cursoDefault.grupoNombre != undefined) {
            nGrupo = cursoDefault.grupoNombre;
          } else {
            nGrupo = cursoDefault.categoriaNombre;
          }

          html += '<div class="step-listado-curso"><h3>' + nGrupo + '</h3><ul class="listado-col">';

          $.each(data.aCursos, function (index, value) {
            if (value.idGrupo != idGrupo) {
              if (value.grupoNombre != undefined) {
                nGrupo = value.grupoNombre;
              } else
                nGrupo = value.categoriaNombre;

              html += '</ul></div><div class="step-listado-curso"><h3>' + nGrupo + '</h3><ul class="listado-col">';
              idGrupo = value.idGrupo;
            }

            if (aCurCupon != '' && aCurCupon != undefined) {
              if($.inArray(value.idCursoComercial, aCurCupon) !== -1)
                html += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip primary-stroke size-s selector-modal-curso" data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sNombre + '" onclick="cargaCupon($(this), \'-modal\')">' + value.sNombre + '</a></li>';
            } else
              html += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip primary-stroke size-s selector-modal-curso" data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sNombre + '" onclick="cargaCupon($(this), \'-modal\')">' + value.sNombre + '</a></li>';
          });

          html += "</ul></div>";

          $("#stepCursoModal").html(html);

          $(".step-modal-categoria-nombre").html(sNombre + '<svg class="i"><use xlink:href="#lapiz"></use></svg>');
          
          $(".slick-form-modal").slick("slickGoTo", 1);
          $(".modal-main-wrapper .pasos span").text("2");

          if(!fullWidth)
            $(".modal-overlay").css("max-width", "1000px");
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
      setTimeout(function () {
        if (curCuponPost != "" && curCuponPost != undefined)
          $('#curso-' + curCuponPost).click();

        $('.slick-form-modal').slick('setPosition');
      }, 1000);

      mostrarOcultarSpinner(false, '#form-modal');
    });
  }
}

function cargaCursosMultistep(element) {
  var idCategoria = element.data('categoria');
  var sNombre = element.data('name');

  if (idCategoria != "") {
    mostrarOcultarSpinner(true, '#form-multistep');

    $("#stepCursoMultistep").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCursos&idCategoria=" + idCategoria,
      success: function (data) {

        data = JSON.parse(data);

        if (!empty(data.aCursos)) {
          html = '';

          $.each(data.aCursos, function (index, value) {            
            if (aCurCupon != '' && aCurCupon != undefined) {
              if($.inArray(value.idCursoComercial, aCurCupon) !== -1)
                html += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip primary-stroke size-s" data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sNombre + '" onclick="cargaCuponMultistep($(this))">' + value.sNombre + '<svg><use xlink:href="#arrow-right"></use></svg></a></li>';
            } else
              html += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip primary-stroke size-s" data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sNombre + '" onclick="cargaCuponMultistep($(this))">' + value.sNombre + '<svg><use xlink:href="#arrow-right"></use></svg></a></li>';
          });

          $("#stepCursoMultistep").html(html);

          $(".multistep-cursos").html(sNombre + '<svg class="i"><use xlink:href="#lapiz"></use></svg>');
          
          $(".slick-form-multistep").slick("slickNext");
          $('#form-multistep .pasos span').text('2');

          if(!fullWidth)
            $(".modal-overlay").css("max-width", "1000px");
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function() {
      $('.slick-form-modal').slick('setPosition');
      mostrarOcultarSpinner(false, '#form-multistep');
    });
  }
}

function cargaCupon(element, isModal = '') {

  var idCursoComercial = element.data('curso-id');
  var sNombre = element.data('name');

  if (idCursoComercial != "") {
    mostrarOcultarSpinner(true, '#form-modal');

    $("#datosCupon").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: 'fn=getCupon&idCursoComercial=' + idCursoComercial +
        '&isModal=' +
        isModal +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb,
      success: function (data) {

        if (data != '') {
          $('#datosCupon').append(data);

          $(".slick-form-modal").slick("slickGoTo", 2);
          $(".modal-main-wrapper .pasos span").text("3");
          $(".modal-main-wrapper .title-cabecera").text("¿Dónde contactamos contigo?");

          if(hideBtnBackModal) {
            $(".modal-main-wrapper .pasos").hide();
            $(".modal-main-wrapper .btn-back").hide();
            $(".modal-main-wrapper .button-row").css('display', 'block');
          }

          if(!fullWidth)
            $(".modal-overlay").css("max-width", "600px");

          enviarEvento();
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
        mostrarOcultarSpinner(false, '#form-modal');

      setTimeout(function () {
        $('.slick-form-modal').slick('setPosition');
      }, 1000);
    });
  }
}

function cargaCuponGeneral(idForm = "frmCupon ", idCursoComercial) {
  if (idCursoComercial != "") {
    mostrarOcultarSpinner(true, '.form-cupon-general');

    $('#' + idForm + "#datosCupon").html("");

    jQuery.ajax({
      type: "POST",
      async: false,
      url: rutajs + "lib/ajax.php",
      data: 'fn=getCupon&idCursoComercial=' + idCursoComercial +
        '&aInstitutos=' +
        JSON.stringify(aInstitutos) +
        '&isModal=' +
        '' +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&idForm=' + idForm.trim(),
      success: function (data) {
        if (data != '') {
          $('#' + idForm + '#datosCupon').append(data);
        }
      },
    }).done(function(){
      mostrarOcultarSpinner(false, '.form-cupon-general');
    });
  } else {
    $('#' + idForm + "#datosCupon").html("");
  }
}

function cargaCuponMultistep(element, isModal = '-multistep') {
  var idCursoComercial = element.data('curso-id');
  var sNombre = element.data('name');

  if (idCursoComercial != "") {
    mostrarOcultarSpinner(true, '#form-multistep');

    $("#datosCuponMultistep").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: 'fn=getCupon&idCursoComercial=' + idCursoComercial +
        '&isModal=' +
        isModal +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb,
      success: function (data) {
        if (data != '') {
          $('#datosCuponMultistep').append(data);

          $(".step-curso-nombre").html(sNombre + '<svg class="i"><use xlink:href="#lapiz"></use></svg>');
          
          $(".slick-form-multistep").slick("slickNext");
          $('#form-multistep .pasos span').text('3');

          if(!fullWidth)
            $(".modal-overlay").css("max-width", "600px");

          enviarEvento();
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
        mostrarOcultarSpinner(false, '#form-multistep');

      setTimeout(function () {
        $('.slick-form-modal').slick('setPosition');
      }, 500);
    });
  }
}

function getComboMD(tipo, required, padre, idForm = "frmCupon ") {
  jQuery.ajax({
    type: "POST",
    async: false,
    url: rutajs + "lib/ajax.php",
    data:
      "fn=getComboMD&tipo=" +
      tipo +
      "&required=" +
      required +
      "&padre=" +
      padre +
      "&idioma_cupon=" +
      idioma_cupon,
    success: function (data) {
      jQuery("#" + idForm + "#" + tipo + "id").html(data);

      if (tipo == "pais") {
        jQuery("#" + idForm + "#" + tipo + "id" + ' select option[value="' + idpais + '"]:first').prop("selected", true);

        configurarCamposCupon(idpais, idForm);
        configurarTelefono(idpais, prefijotelefonico, patterntelefonico, idForm);
      }
    },
  });
}

function chkPais(idpais, idForm = "frmCupon ") {
  $("#" + idForm + "#observaciones").hide(); //campo para guardar el código LADA (solo para méxico)
  $("#" + idForm + "#requeridos_observaciones").val(""); //Para que NO sea obligatorio el campo LADA por servidor (solo para méxico)

  configurarCamposCupon(idpais, idForm);

  if(!$("#" + idForm + "#prefTelf").hasClass("no-change")) {
    jQuery.ajax({
      type: "POST",
      async: false,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCodigosPaises&idpais=" + idpais,
      success: function (data) {
        data = JSON.parse(data);

        configurarTelefono(idpais, data.sCodigoTelefonico, data.sTelefPattern, idForm);
      },
    }).done(function() {
      $('.slick-form-modal').slick('setPosition');
    });
  }
}

function chkPrefijo(sCodigoTelefonico, sCodPais, sTelefPattern, idForm = "frmCupon ", idCampoTelefono = "form_cupon_cupon_telefono") {
  if(!$("#" + idForm + "#prefTelf").hasClass("no-change"))
    $("#" + idForm + "#prefTelf").addClass("no-change")

  $("#" + idForm + '#observaciones').hide(); //campo para guardar el código LADA (solo para méxico)
  $("#" + idForm + '#requeridos_observaciones').val(''); //Para que NO sea obligatorio el campo LADA por servidor (solo para méxico)
  
  configurarTelefono(sCodPais, sCodigoTelefonico, sTelefPattern, idForm, idCampoTelefono);

  $("#" + idForm + '.telefono').unbind('mouseover mouseout').off();
}

function configurarCamposCupon(idpais, idForm = "frmCupon ") {
  /* CAMBIAR LOS IDS DE LOS CAMPOS SI ES NECESARIO */
  /***/
  /***/ idCampoCodigoPostal = "form_cupon_cupon_codigopostal";
  /***/ idCampoProvincia = "provinciaid";
  /***/
  /* ********************************************* */

  if (idpais == 90 || idpais == 'ES') {

    getComboMD("provincia", "true", idpais, idForm);
    
    $("#" + idForm + "#" + idCampoCodigoPostal).attr("required", true);
    $("#" + idForm + "#" + idCampoCodigoPostal).show();
    $("#" + idForm + "." + idCampoCodigoPostal).show();
    $("#" + idForm + "#" + idCampoProvincia).attr("required", true);
    $("#" + idForm + "#" + idCampoProvincia).show();
    $("#" + idForm + "." + idCampoProvincia).show();

    $("#" + idForm + "#requeridos_codigo_postal").val("codigopostal"); //Para que sea obligatorio el campo código postal                $('#provinciaid').attr('required',true);
    $("#" + idForm + "#requeridos_provincia").val("provinciaid"); //Para que sea obligatorio el campo provincia

  } else if (idpais == 249 || idpais == 61) {

    getComboMD("provincia", "true", idpais, idForm);

    $("#" + idForm + "#" + idCampoProvincia).attr("required", true);
    $("#" + idForm + "#" + idCampoProvincia).show();
    $("#" + idForm + "." + idCampoProvincia).show();
    $("#" + idForm + "#" + idCampoCodigoPostal).attr("required", false);
    $("#" + idForm + "#" + idCampoCodigoPostal).val(""); //Para que NO sea obligatorio el campo código postal
    $("#" + idForm + "#" + idCampoCodigoPostal).hide();
    $("#" + idForm + "." + idCampoCodigoPostal).hide();

    $("#" + idForm + "#requeridos_codigo_postal").val(""); //Para que NO sea obligatorio el campo código postal
    $("#" + idForm + "#requeridos_provincia").val("provinciaid"); //Para que sea obligatorio el campo provincia
  } else {

    $("#" + idForm + "#" + idCampoProvincia).attr("required", false);
    $("#" + idForm + "#" + idCampoProvincia).hide();
    $("#" + idForm + "." + idCampoProvincia).hide();
    $("#" + idForm + "#" + idCampoProvincia + ' option[value=""]').prop("selected", true);
    $("#" + idForm + "#" + idCampoCodigoPostal).attr("required", false);
    $("#" + idForm + "#" + idCampoCodigoPostal).val(""); //Para que NO sea obligatorio el campo código postal
    $("#" + idForm + "#" + idCampoCodigoPostal).hide();
    $("#" + idForm + "." + idCampoCodigoPostal).hide();

    $("#" + idForm + "#requeridos_codigo_postal").val(""); //Para que NO sea obligatorio el campo código postal
    $("#" + idForm + "#requeridos_provincia").val(""); //Para que NO sea obligatorio el campo provincia
  }
}

function configurarTelefono(idpais, codigoTelefonico, pattern, idForm = "frmCupon ", idCampoTelefono = "form_cupon_cupon_telefono") {

  $("#" + idForm + '#prefTelf').find('.prefijo-box').html('+' + codigoTelefonico.replace(/^0+/, ''));

  if (empty(pattern)) {
    $("#" + idForm + "#" + idCampoTelefono).removeAttr("pattern");
  } else {
    $("#" + idForm + "#" + idCampoTelefono).attr("pattern", pattern);
  }

  if (idpais == 90 || idpais == 'ES') {

    maxlengthTelefono = 9;
    minlengthTelefono = 9;

    $("#" + idForm + "#" + idCampoTelefono).attr("maxlength", maxlengthTelefono);
    $("#" + idForm + "#" + idCampoTelefono).attr("minlength", minlengthTelefono);
  } else {
    maxlengthTelefono = 25;
    const [min, max] = Array.from(pattern.matchAll(/\d+/g));

    $("#" + idForm + "#" + idCampoTelefono).attr("maxlength", max[0]);
    $("#" + idForm + "#" + idCampoTelefono).attr("minlength", min[0]);
  }

  $("#" + idForm + '#form_cupon_prefijo').val(codigoTelefonico);
}

function restringirCampoNumerico(idCampo, idForm = "frmCupon ") {
  $("#" + idForm + "#" + idCampo).on("input", function () {
    $(this).keyup(function (key) {
      if ($.isNumeric($(this).val()) === false) {
        $(this).val(
          $(this)
            .val()
            .replace(/[^0-9\.]/g, "")
        );
      }
    });
  });
}

/**
 *
 * @param {*} idForm
 * @param {*} iframe | on / off[default]
 */
function setForwardUrl(idForm, iframe) {
  var baseUrl = rutaweb + rutajs;
  var idEstudio = $("#" + idForm + " #form_cupon_idcurso").val();
  var telefono = $("#" + idForm + " #form_cupon_cupon_telefono").val();
  var nombre = $("#" + idForm + " #form_cupon_cupon_nombre").val();
  var transaction_id = $("#" + idForm + " #form_cupon_cupon_transaction_id").val();
  var adsid = $("#" + idForm + " #form_cupon_cupon_adsid").val();
  iframe = iframe === undefined ? "" : "&iframe=on";

  if (compruebaTelefonoCaracteres(idForm, "form_cupon_cupon_telefono"))
    return false;
  if (compruebaCampoVacio(idForm, "form_cupon_cupon_nombre"))
    return false;

  var htmlSpinner =
    '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';

  $("#" + idForm + "#btnInformacion").attr("disabled", true);
  $("#" + idForm + "#btnInformacion").html(htmlSpinner);

  if (typeof rutamainjs === "undefined") baseUrl = rutaweb + rutajs;
  else baseUrl = rutaweb + rutamainjs;

  $("#" + idForm + " #forward_url").val(
    baseUrl +
      "gracias?codCursoReal=" +
      idEstudio +
      "&telefono=" +
      telefono +
      "&nombre=" +
      nombre +
      "&transaction_id=" +
      transaction_id +
      "&adsid=" +
      adsid +
      iframe
  );
  enviarEventoFormulario(0, idForm);
  enviarEventoFormulario(3, idForm);
  return true;
}

function getTipoCurso(idTipo = '', idForm = "frmCupon ") {
  var valorTipo = 'undefined';

  if(!empty(idTipo)) {
    if (idTipo == 1)
      valorTipo = 'oposicion';
    else if (idTipo == 2)
      valorTipo = 'curso';
    else if (idTipo == 3)
      valorTipo = 'fp';
  } else {
    valorTipo = $('#' + idForm).find('#tipoCuponGeneral option:selected').html(); // Este valor está en el cupón del modal
    if (typeof valorTipo === 'undefined'){ // Si no estoy en el modal, cojo el valor del cupón de la ficha
      valorTipo = $('#' + idForm).find('#form_cupon_tipo_curso').val();
      if (typeof valorTipo === 'undefined'){ // Si estoy en un centro lo cojo del select del curso
        valorTipo = $('#' + idForm).find('#form_cupon_idcurso option:selected').attr("data-formacion");
      }
    }
  
    if (typeof valorTipo === 'undefined')
      valorTipo = 'undefined';
  
    if (valorTipo == '-- Oposiciones --')
      valorTipo = 'oposicion';
    else if (valorTipo == '-- Cursos --')
      valorTipo = 'curso';
    else if (valorTipo == '-- FP --')
      valorTipo = 'fp';
  }

  return valorTipo;
}

function enviarEvento(){
  var valorTipo = getTipoCurso();
  var valorCategoria = $('#form_cupon_categoria').val();
  var valorCurso = $('#form_cupon_nombre_curso').val();

  window.dataLayer = window.dataLayer|| [];
  window.dataLayer.push({
  event: 'form_submit',
  step: '1',
  template: v_template,
  menu_level_1: v_menu_level_1,
  menu_level_2: v_menu_level_2,
  menu_level_3: v_menu_level_3,
  menu_level_4: v_menu_level_4,
  menu_level_5: v_menu_level_5,
  form_id: datalayerFormID,
  form_specialization: valorTipo, // Aquí queremos saber qué ha elegido CURSO | OPOSICIONES | FP
  form_category: valorCategoria, // Aquí la categoría de la elección anterior. 
  form_course: valorCurso, // Aquí el curso que ha elegido en función de la categoria.
  form_type: valorTipoCupon,
  form_name: v_form_name,
  page_path: v_page_path,
  page_url: v_page_url
  });
}

function enviarEventoFormulario(tipoEvento = 0, idForm = "frmCupon", idTipo = ''){
  var valorTipo = getTipoCurso(idTipo, idForm);

  valorTipoCupon = $('#' + idForm).find('#tipo_cupon').val();
  if (typeof valorTipoCupon === 'undefined')
    valorTipoCupon = 'PDP';

  var valorCategoria = v_form_category = $('#' + idForm).find('#form_cupon_categoria').val();
  if (typeof valorCategoria === 'undefined') {
    var valorCategoria = 'undefined';
    var v_form_category = 'undefined';
  }

  var valorCurso = $('#' + idForm).find('#form_cupon_nombre_curso').val();
  if (typeof valorCurso === 'undefined')
    var valorCurso = 'undefined';

  var valorPais = $('#' + idForm).find('#paisid option:selected').html();
  if (valorPais == '-- Pais --' || typeof valorPais === 'undefined')
    valorPais = 'undefined';
  
  var valorProvincia = $('#' + idForm).find('#provinciaid option:selected').html();
  if(valorProvincia == '-- Provincia --' || valorProvincia == '-- Estado --' || valorProvincia == '-- MARCA TU PROVINCIA --' || typeof valorProvincia === 'undefined')
    valorProvincia = 'undefined';

  var valorNacionalidad = $('#' + idForm).find('#nacionalidad option:selected').html();
  if (valorNacionalidad == '-- Nacionalidad --' || valorNacionalidad == '-- MARCA TU NACIONALIDAD --' || typeof valorNacionalidad === 'undefined')
    valorNacionalidad = 'undefined';

  var valorEdad = $('#' + idForm).find('#edad option:selected').html();
  if (valorEdad == '-- Edad --' || typeof valorEdad === 'undefined')
    valorEdad = 'undefined';

  var valorEstudios = $('#' + idForm).find('#estudiosid option:selected').html();
  if (valorEstudios == '-- Nivel de estudios --' || '-- Nivel Estudios --' || '-- MARCA TUS ESTUDIOS --' || typeof valorEstudios === 'undefined')
    valorEstudios = 'undefined';

  var valorCentro = $('#' + idForm).find('#form_cupon_centros').val();
  if (typeof valorCentro === 'undefined')
    valorCentro = 'undefined';

  var valorInstituto = $('#' + idForm).find('#form_cupon_instituto').val();
  if (typeof valorInstituto === 'undefined')
    valorInstituto = 'undefined';

  // Recogemos valor de Nombre, Email, Teléfono y CP y los hasheamos
  var valorNombre = $('#' + idForm).find('#form_cupon_cupon_nombre').val();
  var valorCP = $('#' + idForm).find('#form_cupon_cupon_codigopostal').val();
  var valorEmail = $('#' + idForm).find('#form_cupon_cupon_email').val();
  var valorTelefono = $('#' + idForm).find('#form_cupon_cupon_telefono').val();
  if(empty(valorEmail)) {
    valorEmail = 'undefined';
    valorHashEmail = 'undefined';
    valorHashStandardEmail = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorEmail,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashEmail = data.cadena;
      },
      error: function() {
        valorHashEmail = 'undefined';
      }
    });


    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorEmail,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardEmail = data.cadena;
      },
      error: function() {
        valorHashStandardEmail = 'undefined';
      }
    });
  }
  if(empty(valorTelefono)) {
    valorTelefono = 'undefined';
    valorHashTelefono = 'undefined';
    valorHashStandardTelefono = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorTelefono,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashTelefono = data.cadena;
      },
      error: function() {
        valorHashTelefono = 'undefined';
      }
    });
    
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorTelefono,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardTelefono = data.cadena;
      },
      error: function() {
        valorHashStandardTelefono = 'undefined';
      }
    });
  }

  if(empty(valorNombre)) {
    valorNombre = 'undefined';
    valorHashNombre = 'undefined';
    valorHashStandardNombre = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=quitaMayusculasYacentos&cadena='+valorNombre,
      success: function(data) {     
        valorNombreSinAcentos = data;
      },
      error: function() {
        valorNombreSinAcentos = 'undefined';
      }
    });

    if(valorNombreSinAcentos != 'undefined' && valorNombreSinAcentos.trim().length !== 0) {
  
      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHABase64&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashNombre = data.cadena;
        },
        error: function() {
          valorHashNombre = 'undefined';
        }
      });
  
      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHA&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashStandardNombre = data.cadena;
        },
        error: function() {
          valorHashStandardNombre = 'undefined';
        }
      });
    } else {
      valorHashNombre = 'undefined';
      valorHashStandardNombre = 'undefined';
    }
  }

  if(empty(valorCP)) {
    valorCP = 'undefined';
    valorHashCP = 'undefined';
    valorHashStandardCP = 'undefined';
  } else {

    // solo le quitamos espacios y guiones al valor hasheado
    var valorCP_2 = valorCP;

    if (valorCP_2.includes(" ")) {
      valorCP_2 = valorCP_2.replace(/\s+/g, ""); // Elimina todos los espacios
    }
    if (valorCP_2.includes("-")) {
      valorCP_2 = valorCP_2.replace(/-/g, ""); // Elimina todos los guiones
    }
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorCP_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashCP = data.cadena;
      },
      error: function() {
        valorHashCP = 'undefined';
      }
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorCP_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardCP = data.cadena;
      },
      error: function() {
        valorHashStandardCP = 'undefined';
      }
    });
  }

  if(empty(valorPais)) {
    valorPais = 'undefined';
    valorHashPais = 'undefined';
    valorHashStandardPais = 'undefined';
  } else {

    // solo le quitamos espacios y guiones al valor hasheado
    var valorPais_2 = valorPais;

    if (valorPais_2.includes(' ')) {
      valorPais_2 = valorPais_2.replace(/\s+/g, ''); // Elimina todos los espacios
    }
    if (valorPais_2.includes('-')) {
      valorPais_2 = valorPais_2.replace(/-/g, ''); // Elimina todos los guiones
    }
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorPais_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashPais = data.cadena;
      },
      error: function() {
        valorHashPais = 'undefined';
      }
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorPais_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardPais = data.cadena;
      },
      error: function() {
        valorHashStandardPais = 'undefined';
      }
    });
  }
  
  var valorTransaction = $('#' + idForm).find('#transactionIdWeb').val();
  if (typeof valorTransaction === 'undefined')
    valorTransaction = 'undefined';

  if (tipoEvento == 0){
    window.dataLayer = window.dataLayer|| [];
    window.dataLayer.push({
    event: 'form_submit',
    step: '2',
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    form_id: datalayerFormID,
    form_type: valorTipoCupon,
    form_specialization: valorTipo, // Aquí queremos saber qué ha elegido CURSO | OPOSICIONES | FP
    form_category: valorCategoria, // Aquí la categoría de la elección anterior. 
    form_course: valorCurso, // Aquí el curso que ha elegido en función de la categoria.
    form_province: valorProvincia, // Queremos saber de qué provincia es.
    form_nationality: valorNacionalidad, // Queremos saber de qué nacionalidad es.
    form_age: valorEdad, // Queremos saber la edad escogida. 
    form_education: valorEstudios, // Queremos el nivel de estudios que ha indicado 
    form_centre: valorCentro,
    form_institute: valorInstituto,
    form_name: v_form_name,
    hashed_country: valorHashPais, // Queremos saber de qué país es.
    hashed_cp: valorHashCP, // Queremos saber el código postal.
    hashed_country_edu: valorHashStandardPais,
    hashed_cp_edu: valorHashStandardCP,
    page_path: v_page_path,
    page_url: v_page_url
    });
  }else if (tipoEvento == 1){ // view_form
    var aFields = [];

    $('#' + idForm).find('input, select, textarea').each(function() {
      if (this.name && this.type !== 'hidden' && $(this).is(':visible') && aFields.indexOf(this.name) === -1) {
        aFields.push(this.name);
      }
    });

    aFields = aFields.join(',');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_form",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      form_id: datalayerFormID,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_modality: v_modality,
      form_fields: aFields,
      page_path: v_page_path,
      page_url: v_page_url,
    });
    
  }else if (tipoEvento == 2){ // form_start
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_start",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      form_id: datalayerFormID,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_course: valorCurso,
      form_modality: v_modality,
      cta_copy: v_cta_copy,
      cta_section: v_cta_seccion,
      start_field: startField,
      page_path: v_page_path,
      page_url: v_page_url,
    });
  }else if (tipoEvento == 3){ // generate_lead
    var valorCursoId = $('#' + idForm).find('#form_cupon_idcurso_real').val();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "generate_lead",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      edu_pid: valorCursoId,
      transaction_id: valorTransaction,
      form_id: datalayerFormID,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_course: valorCurso,
      form_modality: v_modality,
      form_age: valorEdad,
      form_education: valorEstudios,
      form_province: valorProvincia,
      form_centre: valorCentro,
      form_institute: valorInstituto,
      form_nationality: valorNacionalidad,
      hashed_mail: valorHashEmail,
      hashed_phone: valorHashTelefono,
      hashed_cp: valorHashCP,
      hashed_name: valorHashNombre,
      hashed_mail_edu: valorHashStandardEmail,
      hashed_phone_edu: valorHashStandardTelefono,
      hashed_cp_edu: valorHashStandardCP,
      hashed_name_edu: valorHashStandardNombre,
      page_path: v_page_path,
      page_url: v_page_url,
    });
    
  }else if (tipoEvento == 4){ // error_form
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "error_form",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      transaction_id: valorTransaction,
      form_id: datalayerFormID,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_course: valorCurso,
      form_modality: v_modality,
      form_age: valorEdad,
      form_education: valorEstudios,
      form_province: valorProvincia,
      form_centre: valorCentro,
      form_institute: valorInstituto,
      form_nationality: valorNacionalidad,
      hashed_mail: valorHashEmail,
      hashed_phone: valorHashTelefono,
      hashed_cp: valorHashCP,
      hashed_mail_edu: valorHashStandardEmail,
      hashed_phone_edu: valorHashStandardTelefono,
      hashed_cp_edu: valorHashStandardCP,
      cta_copy: v_cta_copy,
      cta_section: v_cta_seccion,
      page_path: v_page_path,
      page_url: v_page_url,
      error_field: errorField,
      error_message: errorMessage,
    });
  }
}

function mostrarOcultarSpinner(mostrar, elementoContenedor) {
  var htmlSpinner =
      '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
  var spinnerContenedor = "<div class='spinner-contenedor'></div>";

  if (mostrar) {
      $(spinnerContenedor).appendTo(elementoContenedor);
      $('.spinner-contenedor').html(htmlSpinner);
  } else {
    $('.spinner-contenedor').remove();
  }
}

function setDatosCurso(idForm = "frmCupon ", centro, multi = false) {
  if(centro.trim().toLowerCase() === 'online') {
    $('#' + idForm + '#tipoTitulacion').val("FP Online");
    
    if(!multi)
      $('#' + idForm + '#form_cupon_idcurso').val($('#' + idForm + '#form_cupon_idcurso').data('codigo-online'));
  } else {
    $('#' + idForm + '#tipoTitulacion').val("FP Presencial");
    
    if(!multi)
      $('#' + idForm + '#form_cupon_idcurso').val($('#' + idForm + '#form_cupon_idcurso').data('codigo-presencial'));
  }
}

function cargaInstituto(idForm = "frmCupon ", idCurso, idCentro) {

  if (idLanding != '' && idLanding != undefined)
    var esLanding = true;
  else
    var esLanding = false;

  jQuery.ajax({
    type: "POST",
    async: false,
    url: rutajs + "lib/ajax.php",
    data: "fn=getInstitutoCurso&idCurso=" + idCurso + "&idCentro=" + idCentro + "&esLanding=" + esLanding,
    success: function (data) {
      data = JSON.parse(data);
      
      if (!empty(data.curso)) {
        $('#' + idForm + '#form_cupon_instituto').val(data.curso.sInstituto);
      }
    },
  });
}

function cargaDatosCurso(idForm = "frmCupon ") {
  $('#' + idForm + '#form_cupon_categoria').val($('#' + idForm + '#form_cupon_idcurso option:selected').data('categoria'));
  $('#' + idForm + '#form_cupon_nombre_curso').val($('#' + idForm + '#form_cupon_idcurso option:selected').data('nombre-curso'));
  $('#' + idForm + '#form_cupon_idcurso_real').val($('#' + idForm + '#form_cupon_idcurso option:selected').data('id-curso-real'));
  $('#' + idForm + '#form_cupon_instituto').val($('#' + idForm + '#form_cupon_idcurso option:selected').data('instituto'));
}

function compruebaTelefonoCaracteres(form_id, telefono) {
  var nTelefono = $("#" + form_id + " #" + telefono).val();
  var inputTelefono = document.getElementById(telefono);

  let n = nTelefono.length;
  for (let i = 1; i < n; i++) if (nTelefono[i] != nTelefono[0]) return false;

  $("#" + form_id + " #" + telefono).val("");
  inputTelefono.reportValidity();

  return true;
}

function compruebaCampoVacio(form_id, campo) {
  var nCampo = $("#" + form_id + " #" + campo).val();
  var inputCampo = document.getElementById(campo);

  if (nCampo.trim().length !== 0) return false;

  $("#" + form_id + " #" + campo).val("");
  inputCampo.reportValidity();

  return true;
}

function validarCMB(form_id) {
  var result = false;
  var nombre = $('#' + form_id + ' #input-nombre').val();
  var telefono = $('#' + form_id + ' #input-telefono').val();

  if(empty(nombre)) {
    $('#' + form_id + ' #error-nombre').show();

    return false;
  }

  if (compruebaTelefonoCaracteres(form_id, "input-telefono")) {
    $('#' + form_id + ' #error-telefono').show();

    return false;
  }

  $('#' + form_id + ' #error-nombre').hide();
  $('#' + form_id + ' #error-telefono').hide();
  
  $('#' + form_id + ' #btn-llamame-ahora-custom').addClass('hide-llamamos');

  jQuery.ajax({
    type: 'POST',
    async: false,
    url: rutajs + "lib/ajax.php",
    data : 'fn=putLlamamos&wru='+cdn_rutaweb+cdn_rutaactual+'&iw='+cdn_idweb+'&rcdn='+cdn_rutacdn+'&t='+telefono+'&n='+nombre,
    success: function(data) {
      if(data == 1) {
        errorField = 'general';
        errorMessage = 'Algo no ha salido bien';

        enviarEventoFormulario(4, form_id);

        result = false;
      } else {
        eventoCustomCMB(nombre, telefono);

        result = true;
      }
    },
    error: function() {
      errorField = 'general';
      errorMessage = 'Algo no ha salido bien';

      enviarEventoFormulario(4, form_id);

      result = false;
    }
  });

  if(!result)
    alert('Envio incorrecto. Se ha producido un error, por favor, vuelva a intentarlo pasados unos minutos.')

  return result;
}

function eventoCustomCMB(valorNombre, phone) {
  if(empty(phone)) {
    phone = 'undefined';
    valorHashTelefono = 'undefined';
    valorHashStandardTelefono = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+phone,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashTelefono = data.cadena;
      },
      error: function() {
        valorHashTelefono = 'undefined';
      }
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+phone,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardTelefono = data.cadena;
      },
      error: function() {
        valorHashStandardTelefono = 'undefined';
      }
    });
  }

  if(empty(valorNombre)) {
    valorNombre = 'undefined';
    valorHashNombre = 'undefined';
    valorHashStandardNombre = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=quitaMayusculasYacentos&cadena='+valorNombre,
      success: function(data) {     
        valorNombreSinAcentos = data;
      },
      error: function() {
        valorNombreSinAcentos = 'undefined';
      }
    });

    if(valorNombreSinAcentos != 'undefined' && valorNombreSinAcentos.trim().length !== 0) {
  
      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHABase64&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashNombre = data.cadena;
        },
        error: function() {
          valorHashNombre = 'undefined';
        }
      });
  
      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHA&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashStandardNombre = data.cadena;
        },
        error: function() {
          valorHashStandardNombre = 'undefined';
        }
      });
    } else {
      valorHashNombre = 'undefined';
      valorHashStandardNombre = 'undefined';
    }
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "form_submit",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    form_id: datalayerFormID,
    form_modality: v_modality,
    form_type: 'Modal',
    form_name: v_form_name,
    hashed_name: valorHashNombre,
    hashed_phone: valorHashTelefono,
    hashed_name_edu: valorHashStandardNombre,
    hashed_phone_edu: valorHashStandardTelefono,
    cta_copy: v_cta_copy,
    cta_section: v_cta_seccion,
    page_path: v_page_path,
    page_url: v_page_url
  });
}

function enviarEventoViewForm(idForm = "frmCupon"){
  enviarEventoFormulario(1, idForm);
}

function contieneClasesEnArray(clases){
  var contiene = false;

  if(!empty(clases)) {
    var aClases = clases.split(' ');

    $.each(aClases, function (key, value) {
      if(jQuery.inArray(value, aClasesMakingScience) != -1)
        contiene = true;
    });
  }
  
  return contiene;
}

$(document).on('click', '.cta_menu_header',  function(e){
  if(!empty($(this).parent().parent().parent().parent().parent().parent().parent().parent().prev('.cta_menu_header').text().trim())) {
    var v_menu_category = $(this).parent().parent().parent().parent().parent().parent().parent().parent().prev('.cta_menu_header').text().trim().toUpperCase();
    var v_menu_subcategory = $(this).text().trim().toUpperCase();

    v_cta_copy = v_menu_subcategory;
  } else {
    var v_menu_category = $(this).text().trim().toUpperCase();
    var v_menu_subcategory = 'undefined';

    v_cta_copy = v_menu_category;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_menu_header",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    nav_category: v_menu_category,
    nav_subcategory: v_menu_subcategory,
    cta_name: "menu_header",
    cta_copy: v_cta_copy,
    page_path: v_page_path,
    page_url: v_page_url
  });
});

$(document).on('click', '.cta_menu_footer',  function(e){
  if(!empty($(this).parent().parent().parent().prev('.cta_menu_footer').attr('data-texto'))) {
    var v_menu_category = $(this).parent().parent().parent().prev('.cta_menu_footer').attr('data-texto').toUpperCase();
  } else if(!empty($(this).parent().parent().prev('.cta_menu_footer').text().trim())) {
    var v_menu_category = $(this).parent().parent().prev('.cta_menu_footer').text().trim().toUpperCase();
  } else {
    var v_menu_category = $(this).text().trim().toUpperCase();
  }

  v_cta_copy = v_menu_category;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_menu_footer",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    nav_category: v_menu_category,
    cta_name: "menu_footer",
    cta_copy: v_cta_copy,
    page_path: v_page_path,
    page_url: v_page_url
  });
});

$(document).on('click', 'a, button',  function(e){
  if(!contieneClasesEnArray($(this).attr('class'))) {

    if(!empty($(this).text().trim()))
      v_cta_copy = $(this).text().trim();
    else if(!empty($(this).attr('title')))
      v_cta_copy = $(this).attr('title');
    else if(!empty($(this).attr('alt')))
      v_cta_copy = $(this).attr('alt');
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "select_content",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      form_specialization: 'oposicion',
      form_modality: v_modality,
      cta_name: "GENERIC", 
      cta_copy: v_cta_copy.toUpperCase(), 
      page_path: v_page_path,
      page_url: v_page_url
    });
  }
});

$(document).on('click', '.carousel',  function(e){
  var v_carousel_name = $(this).parent().parent().parent().attr('data-name');
  
  if(v_carousel_name != undefined) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "carousel",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      form_specialization: 'oposicion',
      form_modality: v_modality,
      carousel_name: v_carousel_name.toUpperCase(),
      page_path: v_page_path,
      page_url: v_page_url
    });
  }
});

$(document).on('click', '.cta_cmb',  function(e){
  v_cta_copy = $(this).text().trim();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_cmb",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    form_specialization: 'oposicion',
    form_modality: v_modality,
    cta_name: 'CMB',
    cta_copy: v_cta_copy.toUpperCase(),
    page_path: v_page_path,
    page_url: v_page_url
  });
});

$(document).on('click', '.click_cmb',  function(e){
  datalayerFormID = 'form_cmb';

  v_cta_copy = $(this).text().trim();
  v_cta_seccion = $(this).data('position').trim();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "click_cmb",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    form_id: datalayerFormID,
    cta_cmb : v_cta_copy.toUpperCase(),
    cta_seccion: v_cta_seccion,
    page_path: v_page_path,
    page_url: v_page_url
  });
});

$(document).on('click', '.cta_mapa',  function(e){
  var v_map_icon = $(this).attr('data-icon');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_mapa",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    form_specialization: 'oposicion',
    form_modality: v_modality,
    map_icon: v_map_icon.toUpperCase(),
    page_path: v_page_path,
    page_url: v_page_url
  });
});

$(document).on('click', '.share',  function(e){
  var v_share_position = $(this).attr('data-position');
  var v_platform = $(this).attr('data-platform');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "share",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    form_specialization: 'oposicion',
    form_modality: v_modality,
    share_position: v_share_position.toUpperCase(),
    platform: v_platform.toUpperCase(),
    page_path: v_page_path,
    page_url: v_page_url
  });
});

function enviarEventoScrollPage(v_scroll_percentage) {
  var porcentajeActual = $('footer').attr('data-porcentaje');
  var sendEvent = false;

  if(v_scroll_percentage >= 90 && porcentajeActual < 90) {
    sendEvent = true;
    v_scroll_percentage = 90;
  } else if(v_scroll_percentage >= 75 && porcentajeActual < 75) {
    sendEvent = true;
    v_scroll_percentage = 75;
  } else if(v_scroll_percentage >= 50 && porcentajeActual < 50) {
    sendEvent = true;
    v_scroll_percentage = 50;
  } else if(v_scroll_percentage >= 25 && porcentajeActual < 25) {
    sendEvent = true;
    v_scroll_percentage = 25;
  }

  if(sendEvent) {
    $('footer').attr('data-porcentaje', v_scroll_percentage);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "scroll_custom",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      form_specialization: 'oposicion',
      form_modality: v_modality,
      scroll_percentage: v_scroll_percentage,
      page_path: v_page_path,
      page_url: v_page_url
    });
  }
}

function scrollPage() {
  scroll = $(window).scrollTop();
  heightFooter = $('footer').outerHeight();
  totalPage = $('footer').offset().top;

  enviarEventoScrollPage((scroll * 100) / (totalPage - heightFooter));
}

$(window).scroll(function (event) {
  scrollPage();
});

$(window).resize(function (event) {
  scrollPage();
});